import React from 'react';
import { Avatar } from '@business/workflows/ComponentUI/Avatar';
import { NotificationBody } from './NotificationBody';

type Props = {
  title?: string;
  body?: string;
  profileImage?: string;
  actorName?: string;
  onClick?: () => void;
};

/**
 * Card-style toast for real-time share/contribution notifications — mirrors the
 * upload-progress toast design (transparent toastify wrapper + custom card).
 * Shows the sharer/contributor profile picture on the left.
 */
export function NotificationToast({
  title,
  body,
  profileImage,
  actorName,
  onClick
}: Props) {
  return (
    <div
      onClick={onClick}
      className="relative flex w-full items-start gap-3 rounded-xl bg-[#F3FBEA] px-4 py-3 cursor-pointer">
      {/* LEFT: sharer/contributor avatar */}
      <Avatar
        src={profileImage}
        alt={actorName || ''}
        size="h-9 w-9"
        className="flex-shrink-0"
      />

      {/* TEXT */}
      <div className="flex flex-col gap-1 pr-6">
        {title && (
          <div className="text-sm font-bold leading-5 text-[#1E1E1E]">
            {title}
          </div>
        )}
        <div className="max-w-[360px] text-xs font-medium leading-4 text-[#4F7A33]">
          <NotificationBody content={body} actorName={actorName} />
        </div>
      </div>
    </div>
  );
}

export default NotificationToast;
